export const connections = {
  '8501689': {
    en: 'Zermatt',
    de: 'Zermatt',
    lat: 46.0241551,
    lng: 7.7463107,
    distance: 2500,
  },
  '8501688': {
    en: 'Täsch',
    de: 'Täsch',
    lat: 46.0673615,
    lng: 7.7726295,
    distance: 1000,
  },
  '8501605': {
    en: 'Visp',
    de: 'Visp',
    lat: 46.2937655,
    lng: 7.8794054,
    distance: 1000,
  },
  '8501687': {
    en: 'Randa',
    de: 'Randa',
    lat: 46.099984,
    lng: 7.7794053,
    distance: 1000,
  },
  '8501694': {
    en: 'Gornergrat',
    de: 'Gornergrat',
    lat: 45.983343,
    lng: 7.7800023,
    distance: 1000,
  },
  '8501692': {
    en: 'Riffelberg',
    de: 'Riffelberg',
    lat: 45.9929229,
    lng: 7.7528718,
    distance: 1000,
  },
  '8501691': {
    en: 'Riffelalp',
    de: 'Riffelalp',
    lat: 46.004899,
    lng: 7.7521673,
    distance: 1000,
  },
  '8579348': { en: 'Fiesch', de: 'Fiesch' },
  //'8530213': { en: 'Sunnegga-szb', de: 'Sunnegga-szb', lat: 46.017133, lng: 7.7678343, distance: 1000 },
  '8507000': {
    en: 'Bern HB',
    de: 'Bern HB',
    lat: 46.948996,
    lng: 7.4363383,
    distance: 10000,
  },
  '8503000': {
    en: 'Zürich HB',
    de: 'Zürich HB',
    lat: 47.377923,
    lng: 8.5380011,
    distance: 10000,
  },
  '8503016': { en: 'Zürich Airport', de: 'Zürich Flughafen' },
  '8501008': {
    en: 'Geneva HB',
    de: 'Genf Bahnhof',
    lat: 46.210553,
    lng: 6.1408309,
    distance: 10000,
  },
  '8501026': { en: 'Geneva Airport', de: 'Flughafen Genf' },
  '8500010': {
    en: 'Basel HB',
    de: 'Basel HB',
    lat: 47.547589,
    lng: 7.5874733,
    distance: 10000,
  },
  '8500682': { en: 'Basel Airpot', de: 'Basel Flughafen' },
  '8573140': { en: 'Andermatt', de: 'Andermatt' },
  '8576333': { en: 'Spiez Bahnhof', de: 'Spiez Bahnhof' },
  '8576376': { en: 'Interlaken Ost, HB', de: 'Interlaken Ost, HB' },
  '8571310': { en: 'Interlaken West, HB', de: 'Interlaken West, HB' },
};



// WEBPACK FOOTER //
// ./src/views/bls/connections.js